import { render, staticRenderFns } from "./myArts.vue?vue&type=template&id=8834cc7c&scoped=true"
import script from "./myArts.vue?vue&type=script&lang=js"
export * from "./myArts.vue?vue&type=script&lang=js"
import style0 from "./myArts.vue?vue&type=style&index=0&id=8834cc7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8834cc7c",
  null
  
)

export default component.exports